// @flow
import { css } from "styled-components";

export const fontSize = (size: number, arSize?: number) => css`
  ${({ theme }) => {
    switch (theme.locale) {
      case "ar":
        return arSize ? `${arSize}px` : theme.minFontSize;
      default:
        return `${size}px`;
    }
  }};
`;

export const rtl = (
  property: string,
  value: string | number,
  rtlValue?: string | number
) => {
  if (rtlValue != null) {
    return css`
      ${property}: ${({ theme }) =>
        theme.direction === "rtl" ? rtlValue : value};
    `;
  }

  switch (property) {
    case "text-align":
      return css`
        ${({ theme }) => {
          switch (true) {
            case theme.direction === "rtl" && value === "left":
            case theme.direction === "ltr" && value === "right":
              return css`
                ${property}: right;
              `;
            case theme.direction === "rtl" && value === "right":
            case theme.direction === "ltr" && value === "left":
            default:
              return css`
                ${property}: left;
              `;
          }
        }};
      `;
    case "left":
    case "right":
      return css`
        ${({ theme }) => {
          switch (true) {
            case theme.direction === "rtl" && property === "left":
            case theme.direction === "ltr" && property === "right":
              return css`
                right: ${value};
              `;
            case theme.direction === "rtl" && property === "right":
            case theme.direction === "ltr" && property === "left":
            default:
              return css`
                left: ${value};
              `;
          }
        }};
      `;
    default:
      const [prop, suffix] = property.split("-");

      return css`
        ${({ theme }) => {
          switch (true) {
            case theme.direction === "rtl" && suffix === "left":
            case theme.direction === "ltr" && suffix === "right":
              return css`
                ${prop}-right: ${value};
              `;
            case theme.direction === "rtl" && suffix === "right":
            case theme.direction === "ltr" && suffix === "left":
            default:
              return css`
                ${prop}-left: ${value};
              `;
          }
        }};
      `;
  }
};

export const gridFallback = (cols: string, gap: string) => `
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(1/${cols}*100% - (1 - 1/${cols})*${gap});
  margin-bottom: ${gap};

  :not(:nth-of-type(${cols}n + 1)) {
    margin-left: ${gap};
  }

  @supports (display: grid) {
    margin-bottom: 0px;

    :not(:nth-of-type(${cols}n + 1)) {
      margin-left: 0px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/common/styled-mixins.js